import React from 'react'
import "./about.css"
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../Config/Config';


const PAGE_SIZE = 15;

export default function LoyihaHaqida() {
    const [data, setData] = React.useState([]);
    const [search, setSearch] = React.useState("");
    const [page, setPage] = React.useState(1);
    const navigate = useNavigate();

    const goToSubject = (item) => {
        if (item.subject && item.subject_general) {
            navigate(`/boshlangich-talim/${item.subject_general}/${item.subject}`);
        }
    };

    React.useEffect(() => {
        axios
            .get(
                `${baseURL}rtr_base_app/natijalar`
            )
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const filteredData = React.useMemo(() => {
        const query = search.trim().toLowerCase();
        if (!query) return data;
        return data.filter((item) =>
            [item.kasb_kodi, item.fan_nomi, item.talim_muassasa, item.fish, item.guvohnoma_raqami]
                .filter(Boolean)
                .some((field) => field.toLowerCase().includes(query))
        );
    }, [data, search]);

    const totalPages = Math.max(1, Math.ceil(filteredData.length / PAGE_SIZE));
    const currentPage = Math.min(page, totalPages);
    const pagedData = filteredData.slice(
        (currentPage - 1) * PAGE_SIZE,
        currentPage * PAGE_SIZE
    );

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    return (
        <div>
            <Navbar />
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="loyiha_box">
                            <div className="loyiha_text">
                                <p>Kasbiy ta’lim tashkilotlari metodik ta’minоtini yaxshilash, ta'limni raqamlashtirish, axborot va elektron
                                    ta'lim resurslari kontentini yaratish hamda ommalashtirish maqsadida fanlar, modullar va o'quv amaliyotlar bo'yicha raqamli ta'lim resursini ishlab chiqilgan muallif (lar)ning ro'yxati.
                                </p>
                            </div>

                            <div className="loyiha_search">
                                <input
                                    type="text"
                                    placeholder="Qidirish: kasb kodi, fan nomi, muassasa, F.I.Sh, guvohnoma raqami..."
                                    value={search}
                                    onChange={handleSearchChange}
                                />
                            </div>

                            <div className="table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>№</th>
                                            <th>Kasb (mutaxassislik) kodi va nomi</th>
                                            <th>Tayyorlangan fan yoki o‘quv amaliyoti nomi</th>
                                            <th>Ta’lim muassasasi va lavozimi</th>
                                            <th>Familiyasi, ismi, sharifi</th>
                                            <th>Guvohnoma raqami</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagedData.length === 0 ? (
                                            <tr>
                                                <td colSpan={6}>Hech narsa topilmadi</td>
                                            </tr>
                                        ) : (
                                            pagedData.map((item, index) => {
                                                const clickable = Boolean(item.subject && item.subject_general);
                                                return (
                                                    <tr
                                                        key={item.id}
                                                        onClick={() => goToSubject(item)}
                                                        className={clickable ? "loyiha_row_clickable" : ""}
                                                    >
                                                        <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                                        <td>{item.kasb_kodi}</td>
                                                        <td>{item.fan_nomi}</td>
                                                        <td>{item.talim_muassasa}</td>
                                                        <td>{item.fish}</td>
                                                        <td>{item.guvohnoma_raqami}</td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>

                            </div>

                            {totalPages > 1 && (
                                <div className="loyiha_pagination">
                                    <button
                                        type="button"
                                        disabled={currentPage === 1}
                                        onClick={() => setPage(currentPage - 1)}
                                    >
                                        ‹ Oldingi
                                    </button>
                                    <span>{currentPage} / {totalPages}</span>
                                    <button
                                        type="button"
                                        disabled={currentPage === totalPages}
                                        onClick={() => setPage(currentPage + 1)}
                                    >
                                        Keyingi ›
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}